var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "whatsapp-channel-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass:
            "actionButtonBreadcrumb m-0 wp-btn whatsapp-status-button",
          class: ((_obj = {}), (_obj[_vm.getHealthStatus()] = true), _obj),
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.whatsappIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.whatsappIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("WhatsappIcon", {
            staticClass: "whatsapp-channel-icon",
            attrs: {
              color:
                _vm.whatsappIconHovered || _vm.isDropdownVisible
                  ? _vm.getColor
                  : "#3A3F48",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown",
              class: { "dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c(
                "div",
                { staticClass: "dropdown-content" },
                [
                  _vm._l(
                    _vm.filteredBusinessChannels,
                    function (channel, index) {
                      return _vm.filteredBusinessChannels.length > 0
                        ? _c("ChannelStatusItem", {
                            key: channel._id,
                            attrs: { channel: channel },
                            on: { close: _vm.closeDropdown },
                          })
                        : _vm._e()
                    }
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.filteredV2Channels, function (channel, index) {
                    return _vm.filteredV2Channels.length > 0
                      ? _c("ChannelStatusItem", {
                          key: channel._id,
                          attrs: { channel: channel },
                          on: { close: _vm.closeDropdown },
                        })
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.filteredV3Channels, function (channel, index) {
                    return _vm.filteredV3Channels.length > 0
                      ? _c("ChannelStatusItem", {
                          key: channel._id,
                          attrs: { channel: channel },
                          on: { close: _vm.closeDropdown },
                        })
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.filteredV1Channels, function (channel, index) {
                    return _vm.filteredV1Channels.length > 0
                      ? _c("ChannelStatusItem", {
                          key: channel._id,
                          attrs: { channel: channel },
                          on: { close: _vm.closeDropdown },
                        })
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }